export const tableUser = [
    { key: "id", value: "Номер", isActive: true },
    { key: "name", value: "ФИО", isActive: true },
    {key: "login", value:"Логин", isActive: true},
    {key: "tgId", value:"Телеграм", isActive: true},
    {key: "isConfirmed", value:"Активация", isActive: true},
    {key: "role", value:"Роль", isActive: true},
  ]

